/**
 * Orchestration layer for marketing list routes with infinite scroll.
 *
 * Master Rules §2: UI components must not fetch. This module owns pagination
 * side effects via useInfiniteListPatternItems.
 */
import { useInfiniteListPatternItems } from '../hooks/useInfiniteListPatternItems';
import type { ContentListPageShellProps, InfiniteListPatternProps } from '../lib/contentListPageTypes';
import { ContentListPage } from './ContentListPage';

export type InfiniteListContentListPageProps = ContentListPageShellProps & {
  infiniteListProps: InfiniteListPatternProps;
};

export function InfiniteListContentListPage({
  infiniteListProps,
  ...shell
}: InfiniteListContentListPageProps) {
  const { state, loadMore } = useInfiniteListPatternItems(infiniteListProps, shell.title);

  return (
    <ContentListPage
      {...shell}
      infiniteListProps={infiniteListProps}
      infiniteListState={state}
      loadMore={loadMore}
    />
  );
}
